// @flow
import * as React from 'react';

import get from 'lodash/get';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { Product } from '@gandi/cart';

import { withForm, type FormComponentProps } from 'gandi.react-form';

import { withRouter, type WithRouterProps } from 'src/helpers/withRouter';

import type { FullState } from '../../../types';

const errorsToFielsdMap = {
  'server.hostname': 'name',
  'server.authentication.password': 'password',
  'server.authentication.username': 'username',
  'server.authentication.ssh_keys.0': 'sshkey', // only one ssh key field
  'server.location': 'datacenter',
  'server.image': 'system',
};

/*
 * All errors not listed in `errorsToFielsdMap` or in `fields` are ignored.
 *
 * All other errors are maped to the field name key and displayed
 * below the form field.
 */
export function mapErrorsToFields(
  errors?: any,
  fields: Array<string>,
): { [key: string]: string, ... } | void {
  if (!errors) {
    return undefined;
  }

  if (!Array.isArray(errors)) {
    return { _error: errors };
  }

  const mappedErrors = errors.reduce((old, current) => {
    if (
      !errorsToFielsdMap[current.name] ||
      fields.indexOf(errorsToFielsdMap[current.name]) < 0
    ) {
      return old;
    }

    return {
      ...old,
      [errorsToFielsdMap[current.name]]: current.description,
    };
  }, {});

  return Object.keys(mappedErrors).length ? mappedErrors : undefined;
}

export type Query = {
  template?: string,
};

type FormProps = {
  ...WithRouterProps<void, Query>,
  render: (form: FormComponentProps) => any,
  form: FormComponentProps,
  // eslint-disable-next-line react/no-unused-prop-types
  product: ?Product,
};

class Form extends React.Component<FormProps> {
  render(): null | React.Node {
    const toRender = this.props.render(this.props.form);
    return toRender || null;
  }
}

const mapStateToProps = (state: FullState, ownProps: FormProps) => {
  const product = ownProps.product;
  const defaultValues = ownProps.location.query.template
    ? {
        template: ownProps.location.query.template,
      }
    : {};

  // Compute Form initialValues from exisiting product, if any.
  return {
    initialValues: get(product, 'payload.extra', defaultValues),
  };
};

// $FlowFixMe[signature-verification-failure]
export default compose(
  withRouter,
  connect(mapStateToProps),
  withForm({
    enableReinitialize: true,
    form: 'cloud-create-server',
    keepDirtyOnReinitialize: true,
    propNamespace: 'form',
    pure: false,
  }),
)(Form);
